<template>
  <div class="order-page">
    <el-row :gutter="20">
      <el-col
        :lg="18"
        :sm="24">
        <Order/>
      </el-col>
      <el-col
        :lg="6"
        class="visible-lg-block">
        <Basket/>
      </el-col>
    </el-row>
    <div
      v-if="getIsShowLoadData"
      class="load-order">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import Basket from './Basket'
  import Order from './Order'

  export default {
    name: 'OrderPage',
    components: {
      Order,
      Basket
    },
    computed: {
      ...mapGetters('order', [
        'getIsShowLoadData'
      ])
    },
    methods: {
      ...mapActions('order', [
        'initOrder'
      ])
    },
    created: function () {
      this.initOrder()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderPage.vue